import axios from "axios";

export default {
  state: {
    lessonMaterials: null
  },
  mutations: {
    setLessonMaterials(state, payload) {
      state.lessonMaterials = payload;
    }
  },
  actions: {
    getLessonMaterials({ commit }) {
      const { chapter, lesson } = this.getters.user.courseViewLocation;
      commit("setLoading", true);

      if (
        this.getters.lessonMaterialsData &&
        this.getters.lessonMaterialsData.length > 0
      ) {
        commit("setLessonMaterials", this.getters.lessonMaterialsData);
        return commit("setLoading", false);
      }
      const URL = `https://us-central1-meduberet-project.cloudfunctions.net/fetchLessonMaterials?chapter=${chapter}&lesson=${lesson}`;
      axios({
        method: "get",
        url: URL,
        headers: {
          "Content-Type": "text/plain"
        }
      })
        .then(({ data }) => {
          commit("setLessonMaterials", data.materials);
          commit("setLoading", false);
        })
        .catch(err => {
          console.error(err);
          return null;
        });
    }
  },
  getters: {
    lessonMaterials(state) {
      return state.lessonMaterials;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/course/index.js